<template>
  <div class="route-modal">
    <v-container class="faq-container" v-click-outside="close">
      <v-card>
        <v-container>
          <div>
            <v-container fill-height v-if="!error">
              <v-layout align-center justify-center fill-height id="article">
                <v-flex xs12 class="text-center py-5 my-5" v-if="loading">
                  <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
                </v-flex>

                <v-flex v-if="loaded">
                  <article class="py-3">
                    <h1 class="display-1 mb-5">{{ title }}</h1>
                    <div class="headline mb-5" v-if="summary">{{ summary }}</div>
                    <div v-if="description" v-html="description"></div>
                  </article>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container fill-height>
              <v-layout align-center justify-center fill-height>
                <v-flex v-if="error">
                  <v-row>
                    <v-col md="6" offset-md="3">
                      <v-alert
                        :value="true"
                        :dismissible="false"
                        color="primary"
                        dark
                        outlined
                        class="mb-3"
                      >
                        <div class="text-center">Article not found</div>
                      </v-alert>

                      <v-row>
                        <v-col cols="auto" class="mr-auto"></v-col>
                        <v-col cols="auto">
                          <v-btn @click.prevent="() => $router.go(-1)" color="primary">Go back</v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-container>
      </v-card>
    </v-container>
    <v-btn x-large icon color="white" class="close-btn" :to="{name: 'home'}">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import _ from "lodash";
import api from "../api";

export default {
  data: () => ({
    title: null,
    mounted: false,
    summary: null,
    description: null,
    loaded: false,
    loading: false,
    error: false
  }),

  computed: {
    alias: function() {
      return this.$route.params.alias;
    },

    container_style: function() {
      if (this.error) {
        return {
          style: {
            "background-image": "url('/img/home-cover3.jpg')",
            "background-size": "cover"
          }
        };
      } else {
        return {};
      }
    }
  },

  methods: {
    close() {
      if (this.mounted) this.$router.push({ name: "home" });
      // this.$router.push({ name: "search" });
    }
  },

  created: function() {
    this.loading = true;
    api.article
      .show(this.alias)
      .then(response => {
        this.title = _.get(response.data, "title");
        this.summary = _.get(response.data, "summary");
        this.description = _.get(response.data, "description");
        this.loaded = true;
      })
      .catch(error => {
        this.error = true;
      })
      .then(() => {
        this.loading = false;
      });
  },

  mounted: function() {
    setTimeout(() => (this.mounted = true), 0);
  }
};
</script>

